(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klubb-card-swipe"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klubbCardSwipe) return;
    window.klubbCardSwipe = true;
    function update(t) {
      var i = Math.round(t.scrollLeft / Math.max(t.clientWidth, 1));
      var dots = t.parentNode.querySelectorAll('.klubb-cs__dot');
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
    }
    function onScroll(e) {
      var t = e.target;
      if (!t.classList || !t.classList.contains('klubb-cs__track')) return;
      requestAnimationFrame(function () { update(t); });
    }
    document.addEventListener('scroll', onScroll, true);
    document.addEventListener('scrollend', onScroll, true);
    // 15/10 : télécharger les photos du glissement au 1er toucher sur la carte, jamais avant (ni sur ordinateur).
    document.addEventListener('touchstart', function (e) {
      var cs = e.target.closest && e.target.closest('.klubb-cs');
      if (!cs || cs.dataset.charge) return;
      cs.dataset.charge = '1';
      var imgs = cs.querySelectorAll('img[data-src]');
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].srcset = imgs[k].getAttribute('data-srcset');
        imgs[k].src = imgs[k].getAttribute('data-src');
      }
    }, { passive: true, capture: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klubb-gallery-dots"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klubbGalleryDots) return;
    window.klubbGalleryDots = true;
    function setup(gallery) {
      var viewer = gallery.querySelector('.product__media-gallery-viewer');
      var list = viewer && viewer.querySelector('.product__media-list');
      if (!list || viewer.querySelector(':scope > .klubb-gd')) return;
      var slides = list.querySelectorAll(':scope > .product__media-item');
      if (slides.length < 2) return;
      var wrap = document.createElement('div');
      wrap.className = 'klubb-gd';
      wrap.setAttribute('aria-hidden', 'true');
      for (var k = 0; k < slides.length; k++) {
        var d = document.createElement('span');
        d.className = 'klubb-gd__dot';
        wrap.appendChild(d);
      }
      viewer.appendChild(wrap);
      function update() {
        var active = 0;
        for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('swiper-slide-active')) active = i;
        for (var j = 0; j < wrap.children.length; j++) wrap.children[j].classList.toggle('is-active', j === active);
      }
      new MutationObserver(update).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
      update();
    }
    function scan() {
      var galleries = document.querySelectorAll('media-gallery');
      for (var i = 0; i < galleries.length; i++) setup(galleries[i]);
    }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klubb-header-search"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klubbHeaderSearch) return;
    window.klubbHeaderSearch = true;
    var OPEN = 'klubb-search-open';
    function close() {
      document.body.classList.remove(OPEN);
      var b = document.querySelector('.klubb-hs');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.klubb-hs');
      if (!btn) return;
      e.preventDefault();
      if (document.body.classList.contains(OPEN)) {
        var x = document.querySelector('.header__search-close');
        if (x) x.click();
        close();
        return;
      }
      document.body.classList.add(OPEN);
      btn.setAttribute('aria-expanded', 'true');
      var input = document.querySelector('.header__search input[type="search"], .header__search .search__input');
      if (input) input.focus();
    });
    // Champ vide : le thème n'active pas « search-open » (recherche sans suggestions), donc on ferme nous-mêmes
    // au clic à côté et sur Échap (audit 05/10).
    function closeAll() {
      if (!document.body.classList.contains(OPEN)) return;
      var x = document.querySelector('.header__search-close');
      if (x && document.body.classList.contains('search-open')) x.click();
      var input = document.querySelector('.header__search .search__input');
      if (input && document.activeElement === input) input.blur();
      close();
    }
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains(OPEN)) return;
      if (e.target.closest && (e.target.closest('.header__search') || e.target.closest('.klubb-hs'))) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    function tag() { var s = document.querySelector('.header__top .header__search'); if (s && !s.id) s.id = 'KlubbHeaderSearch'; }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tag); else tag();
    // Le thème ferme sa recherche (croix, clic à côté, Échap) en retirant « search-open » du body : on replie avec lui.
    new MutationObserver(function () {
      if (document.body.classList.contains(OPEN) && !document.body.classList.contains('search-open')) {
        var input = document.querySelector('.header__search .search__input');
        if (!input || document.activeElement !== input) close();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
